<!--

This component loads the notes associated with a particular module for editing. Notes are classified
with integers to reflect their type. This list can be added to in the future. Be sure to update
the wiki and associated modules if you do so.

Note types:

1. test
2. image
3. document
4. document list

-->
<template>
  <div>

    <!-- This is for data only, nothing visual -->
    {{checkNotes}}

    <div v-for="note in notes">

      <!-- here we load notes to edit based on their type -->

      <!-- text type -->
      <div v-if="note.note_type === 1">
        <component 
          is="text-editor"
          :key="note.id"
          v-bind="{
          noteId: note.id,
          noteName: note.name,
          formData: note.note}">
        </component>
      </div>

      <!-- image type -->
      <!-- -->
      <!-- -->

      <!-- document -->
      <!--
      <div v-if="note.note_type === 3">
        <h5>{{note.name}} | Note Id: {{note.id}}</h5>
        <component
          is="up-loader"
          :key="note.id"
          class="margin-top-1"
          v-bind="{
          noteId: note.id}">
        </component>
      </div>
      -->

      <!-- document list -->
      <div v-if="note.note_type === 3" class="mt-5">
        <h5>{{note.name}} | Note Id: {{note.id}}</h5>
        <collapse-view
          class="col mt-3 mr-3"
          group="faq"
          :slot-id="note.id"  
          :title="note.name">
          <component
            is="multi-uploader"
            :key="note.id"
            class="mt-3"
            v-bind="{
            noteId: note.id}">
          </component>
        </collapse-view>
      </div>

    </div>

  </div>
</template>

<script>
import axios from 'axios'
import TextEditor from './TextEditor'
import UpLoader from '@/components/forms/UpLoader.vue'
import MultiUploader from '@/components/forms/MultiUploader'
import CollapseView from '@/components/display-utils/CollapseView.vue'

export default {
  components: {
    TextEditor,
    UpLoader,
    MultiUploader,
    CollapseView
  },
  data () {
    return {
      news: "",
      notes: []
    }
  },
  props:['moduleId'],
  mounted: function() {
    this.getData()
  },
  computed: {
    checkNotes: function() {
      //checks the number of available notes. updates number of TextEditors
      if (this.$store.getters.getModuleCheck == true) {
        this.getData()
        this.$store.commit('setModulecheck',false)
      }
    }
  },
  methods: {
    getData: function() {
      //reset array of notes
      this.notes = [];

      //only get data if there's a valid module id
      if (this.moduleId != 0) {
        //component reference
        let local = this

        //ajax query
        axios({
            method: 'get',
            url: local.$helpers.api() + '/module/notes/' + this.moduleId,
            headers: {'X-Requested-With': 'XMLHttpRequest',
                      'Content-Type': 'application/json'}
          })
          .then(function (response) {
            //create an editor for each note
            local.notes = response.data
          })
          .catch(function (error) {
            console.log("error geting module data: ", error)
        });
      }
    }
  }
}
</script>

<style>

</style>
